import React, { useState, useEffect } from 'react';
import './UserManagement.css';

const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [message, setMessage] = useState('');

  // ユーザーデータを読み込み
  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    try {
      // CSVファイルから直接読み込み（ローカルストレージは無視）
      try {
        const csvResponse = await fetch('/data/users.csv');
        const csvText = await csvResponse.text();
        const csvUsers = parseUsersCSV(csvText);
        
        // ハードコーディングされた管理者ユーザーを追加
        const hardcodedUsers = [
          {
            id: 999,
            username: "admin",
            password: "Adm1n#Pw",
            email: "admin@example.com",
            name: "管理者",
            role: "admin"
          },
          {
            id: 998,
            username: "root",
            password: "Adm1n#Pw",
            email: "root@example.com",
            name: "ルート管理者",
            role: "admin"
          }
        ];
        
        // CSVユーザーとハードコーディングユーザーを結合
        setUsers([...csvUsers, ...hardcodedUsers]);
        console.log('CSVファイルからユーザーデータを読み込みました:', csvUsers);
      } catch (csvError) {
        console.error('CSVファイルの読み込みに失敗しました:', csvError);
        setMessage('CSVファイルの読み込みに失敗しました');
      }
    } catch (error) {
      console.error('ユーザーデータの読み込みに失敗しました:', error);
      setMessage('ユーザーデータの読み込みに失敗しました');
    }
  };



  // CSVファイルを解析
  const parseUsersCSV = (csvContent) => {
    const lines = csvContent.split('\n');
    if (lines.length < 2) return [];

    const headers = lines[0].split(',').map(h => h.trim());
    const users = [];

    for (let i = 1; i < lines.length; i++) {
      const line = lines[i].trim();
      if (!line) continue;

      const values = parseCSVLine(line);
      if (values.length >= headers.length) {
        const user = {};
        headers.forEach((header, index) => {
          user[header] = values[index] || '';
        });
        users.push(user);
      }
    }

    return users;
  };

  // CSV行を解析（カンマ区切り、ダブルクォート対応）
  const parseCSVLine = (line) => {
    const values = [];
    let current = '';
    let inQuotes = false;
    
    for (let i = 0; i < line.length; i++) {
      const char = line[i];
      
      if (char === '"') {
        if (inQuotes && line[i + 1] === '"') {
          current += '"';
          i++; // 次のダブルクォートをスキップ
        } else {
          inQuotes = !inQuotes;
        }
      } else if (char === ',' && !inQuotes) {
        values.push(current.trim());
        current = '';
      } else {
        current += char;
      }
    }
    
    values.push(current.trim());
    return values;
  };

  return (
    <div className="user-management">
      <div className="user-management-header">
        <h2>👥 ユーザー管理</h2>
        <p>登録されているユーザー情報の表示（読み取り専用）</p>
      </div>

      {message && (
        <div className={`message ${message.includes('失敗') ? 'error' : 'success'}`}>
          {message}
        </div>
      )}

              <div className="user-management-content">
          {/* ユーザー一覧 */}
          <div className="user-list-section">
            <h3>ユーザー一覧</h3>
            <div className="user-list">
              {users.map(user => (
                <div key={user.id} className="user-item">
                  <div className="user-info">
                    <div className="user-name">
                      <strong>{user.name}</strong>
                      <span className={`user-role ${user.role}`}>
                        {user.role === 'admin' ? '👑 管理者' : '👤 一般ユーザー'}
                      </span>
                    </div>
                    <div className="user-details">
                      <span>ユーザー名: {user.username}</span>
                      {user.email && <span>メール: {user.email}</span>}
                    </div>
                  </div>
                  <div className="user-actions">
                    <span className="read-only-badge">読み取り専用</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

        {/* 注意事項 */}
        <div className="user-management-notice">
          <h4>⚠️ 注意事項</h4>
          <ul>
            <li>この画面は読み取り専用です。ユーザーの追加・編集・削除はできません</li>
            <li>admin（ID: 999）とroot（ID: 998）はハードコーディングされており、常に利用可能です</li>
            <li>CSVファイルの変更は、ファイルを直接編集してからブラウザを再読み込みしてください</li>
            <li>パスワードは平文で保存されています（本格運用時はハッシュ化推奨）</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default UserManagement; 